import React, { FunctionComponent, JSX } from "react";
import Icon from "@ant-design/icons";
import { IIcon } from "./icons-interfaces";

const ConnectSvg = () => (
  <svg fill="currentColor" width="1em" height="1em" viewBox="0 0 48 48">
    <path d="M21.42,36.36l-3.02,3.02c-2.2,2.2-5.79,2.2-7.99,0l-.43-.43c-1.07-1.07-1.65-2.48-1.65-3.99s.59-2.93,1.65-3.99l9.69-9.69c1.07-1.07,2.49-1.65,3.99-1.65s2.93.59,3.99,1.66l.42.42c.29.29.55.62.78.96.6.93,1.83,1.2,2.76.61s1.2-1.83.61-2.76c-.38-.59-.82-1.14-1.32-1.64l-.43-.43c-1.82-1.82-4.24-2.83-6.82-2.83s-5,1-6.82,2.83l-9.69,9.69c-3.76,3.76-3.76,9.88,0,13.64l.43.43c1.88,1.88,4.35,2.82,6.82,2.82s4.94-.94,6.82-2.82l3.02-3.02c.78-.78.78-2.05,0-2.83-.78-.78-2.05-.78-2.83,0Z" />
    <path d="M41.85,7.94l-.43-.43c-3.76-3.76-9.88-3.76-13.64,0l-2.99,2.98c-.78.78-.78,2.05,0,2.83s2.05.78,2.83,0l2.99-2.99c2.2-2.2,5.78-2.2,7.98,0l.43.43c1.07,1.07,1.65,2.48,1.65,3.99s-.59,2.93-1.65,3.99l-9.69,9.69c-2.2,2.2-5.79,2.2-7.99,0l-.43-.43c-.29-.29-.55-.62-.77-.96-.59-.93-1.83-1.2-2.76-.61-.93.59-1.21,1.83-.61,2.76.38.59.82,1.15,1.32,1.64l.43.43c1.88,1.88,4.35,2.82,6.82,2.82s4.94-.94,6.82-2.82l9.69-9.69c3.76-3.76,3.76-9.88,0-13.64Z" />
  </svg>
);

const ConnectIcon: FunctionComponent<IIcon> = (props): JSX.Element => (
  <Icon className={props.className} component={ConnectSvg} />
);

export default ConnectIcon;
